/**
 * Page constructor
 * @constructor app.editor.stage.Page
 */
fx.ns("shared.stage", class PageTools extends fx.Component {
    
	constructor(page, model)
	{
		super(page);

		this.zoom = model.zoom;

		this.assets = fx.get("assets");
	}

	onReady() {
		super.onReady();

		this.on("click", this.onRemoveClicked, this.removePagesButton);
	}

	create(){
		super.create();
		
        this.removePagesButton = new fx.components.IconButton({className : "action removePagesButton", icon : fx.assets.removeIcon});
        this.removePagesButton.visibleAtStart = false;
        this.removePagesButton.toolTip = fx.text("Supprimer ces 2 pages");
        this.addChild(this.removePagesButton, {height:50, width : 50, top : 10, left : "center" });
	}


    onDisplayUpdated()
    {
        //console.log("updated");
    }
	
	showActions()
	{	
        this.removePagesButton.show();
        this.removePagesButton.addClass("action");
        this.removeEnabled = true;
    
	}

	hideActions()
	{
		this.removePagesButton.hide();
		this.removePagesButton.removeClass("action");
		this.removeEnabled = false;
	}


	onRemoveClicked(e)
	{
		if (this.removeEnabled)
			this.trigger("remove");

		e.preventDefault();
		e.stopPropagation();
	}

});	